import GeneralService from "./GeneralService";

export class OnboardingService {
  public static createOrganization(
    payload: { org_name: string; email: string },
    loadingHandler: (val: boolean) => void = null
  ) {
    return GeneralService.post(
      "/onboarding/organization",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      ""
    );
  }
}
